module.exports = __webpack_public_path__ + "static/thumbsup-72b6f987e11033c4ac841ee529f806f9.webp";